/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 18L18 18M6 6H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 14L18 14M12 10L18 10M8 10L6 12L8 14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M6 18L18 18M12 14L18 14M12 10L18 10M6 6H18M8 10L6 12L8 14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25L14.75 1.25C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27434 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25L22.75 14.75L22.75 14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75L9.25 22.75C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75L1.25 9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27434 3.98005 1.79497ZM6.00009 5.25004C5.58588 5.25004 5.25009 5.58583 5.25009 6.00004C5.25009 6.41425 5.58588 6.75004 6.00009 6.75004L18.0001 6.75004C18.4143 6.75004 18.7501 6.41425 18.7501 6.00004C18.7501 5.58583 18.4143 5.25004 18.0001 5.25004L6.00009 5.25004ZM8.53041 10.5303C8.8233 10.2374 8.8233 9.76255 8.53041 9.46966C8.23752 9.17677 7.76264 9.17677 7.46975 9.46966L5.46975 11.4697C5.17686 11.7626 5.17686 12.2374 5.46975 12.5303L7.46975 14.5303C7.76264 14.8232 8.23752 14.8232 8.53041 14.5303C8.8233 14.2374 8.8233 13.7626 8.53041 13.4697L7.06074 12L8.53041 10.5303ZM12.0001 9.25003C11.5859 9.25003 11.2501 9.58582 11.2501 10C11.2501 10.4142 11.5859 10.75 12.0001 10.75L18.0001 10.75C18.4143 10.75 18.7501 10.4142 18.7501 10C18.7501 9.58582 18.4143 9.25004 18.0001 9.25004L12.0001 9.25003ZM12.0001 13.25C11.5859 13.25 11.2501 13.5858 11.2501 14C11.2501 14.4142 11.5859 14.75 12.0001 14.75L18.0001 14.75C18.4143 14.75 18.7501 14.4142 18.7501 14C18.7501 13.5858 18.4143 13.25 18.0001 13.25L12.0001 13.25ZM6.00009 17.25C5.58588 17.25 5.25009 17.5858 5.25009 18C5.25009 18.4142 5.58588 18.75 6.00009 18.75L18.0001 18.75C18.4143 18.75 18.7501 18.4143 18.7501 18C18.7501 17.5858 18.4143 17.25 18.0001 17.25L6.00009 17.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M6 18L18 18M12 14L18 14M12 10L18 10M6 6H18M8 10L6 12L8 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 18L18 18M12 14L18 14M12 10L18 10M6 6H18M8 10L6 12L8 14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.25001 6C5.25001 5.58579 5.58579 5.25 6.00001 5.25L18 5.25C18.4142 5.25 18.75 5.58579 18.75 6C18.75 6.41422 18.4142 6.75 18 6.75L6.00001 6.75C5.58579 6.75 5.25001 6.41422 5.25001 6ZM8.53033 9.46962C8.82322 9.76251 8.82322 10.2374 8.53033 10.5303L7.06066 12L8.53033 13.4696C8.82322 13.7625 8.82322 14.2374 8.53033 14.5303C8.23744 14.8232 7.76256 14.8232 7.46967 14.5303L5.46967 12.5303C5.17678 12.2374 5.17678 11.7625 5.46967 11.4696L7.46967 9.46962C7.76256 9.17673 8.23744 9.17673 8.53033 9.46962ZM11.25 10C11.25 9.58578 11.5858 9.25 12 9.25L18 9.25C18.4142 9.25 18.75 9.58578 18.75 10C18.75 10.4142 18.4142 10.75 18 10.75L12 10.75C11.5858 10.75 11.25 10.4142 11.25 10ZM11.25 14C11.25 13.5858 11.5858 13.25 12 13.25L18 13.25C18.4142 13.25 18.75 13.5858 18.75 14C18.75 14.4142 18.4142 14.75 18 14.75L12 14.75C11.5858 14.75 11.25 14.4142 11.25 14ZM5.25001 18C5.25001 17.5858 5.58579 17.25 6.00001 17.25L18 17.25C18.4142 17.25 18.75 17.5858 18.75 18C18.75 18.4142 18.4142 18.75 18 18.75L6.00001 18.75C5.58579 18.75 5.25001 18.4142 5.25001 18Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
